<!--特殊权限设置 -->
<template>
  <vxe-modal
    v-model="formVisible"
    title="特殊权限设置"
    width="450px"
    height="600px"
    @show="showWindow"
  >
    <vxe-grid
      border
      ref="xTable"
      size="mini"
      :height="height"
      :cell-class-name="cellClassName"
      resizable
      show-overflow
      :data="from"
      :edit-rules="validRules"
      highlight-hover-row
      highlight-current-row
      :mouse-config="{ area: true, extension: true }"
      :edit-config="{ trigger: 'dblclick', mode: 'cell' }"
      :keyboard-config="{
        isArrow: true,
        isDel: true,
        isEnter: true,
        isTab: true,
        isClip: true,
        enterToTab: true,
        isEdit: true,
        editMethod: editMethod,
      }"
      :toolbar="tableToolbar"
      :columns="gridColumns"
      @toolbar-button-click="toolbarButtonClickEvent"
    >
      <!-- <vxe-table-column type="seq" width="40" cell-type="string"></vxe-table-column>
      <vxe-table-column field="text" title="权限名称" cell-type="string"></vxe-table-column>
      <vxe-table-column field="iHave" title="是否有特殊权限" width="150" align="center">
        <template v-slot:header>
          <vxe-checkbox v-model="iHaveAll" @change="checkboxiHave">是否有特殊权限</vxe-checkbox>
        </template>
        <template v-slot="{ row }">
          <vxe-checkbox v-model="row.iHave"></vxe-checkbox>
        </template>
      </vxe-table-column> -->
    </vxe-grid>
  </vxe-modal>
</template>

<script>
export default {
  props: {
    parentObj: Object,
    modalType: {
      type: String,
      default: 'edit'
    }
  },
  data() {
    return {
      // 是否显示
      formVisible: false,
      menuArgs: '',
      from: [],
      // tabel工具栏
      tableToolbar: {},
      validRules: {},
      errIndex: [],
      roleID: 0,
      bAuthorityListID: 0,
      iHaveAll: false,
      // 列头
      gridColumns: [],
      ifCanSave: false
    }
  },
  created() {
  },
  methods: {
    // 初始化列头
    InitColumn() {
      let that = this
      that.gridColumns = [
        { type: 'seq', width: '40', cellType: 'string' },
        { field: 'text', title: '权限名称', cellType: 'string' },
        {
          field: 'iHave',
          title: '是否有特殊权限',
          align: 'center',
          slots: {
            header: () => {
              return [
                <vxe-checkbox disabled={this.modalType === 'see'} v-model={this.iHaveAll} onChange={
                  () => {
                    this.checkboxiHave()
                  }
                }>是否有特殊权限</vxe-checkbox>
              ]
            },
            default: ({ row }) => {
              return [
                <vxe-checkbox disabled={this.modalType === 'see'} v-model={row.iHave}></vxe-checkbox>
              ]
            }
          }
        }
      ]
    },
    checkboxiHave() {
      let records = this.$refs.xTable.getTableData().fullData
      for (let i = 0; i < records.length; i++) {
        records[i].iHave = this.iHaveAll
      }
    },
    async showWindow() {
      this.iHaveAll = false
      this.from = []
      this.tableToolbar = {
        buttons: [{ code: 'clickToSave', disabled: !this.ifCanSave || this.modalType === 'see', name: '保存' }]
      }
      this.InitColumn()
      this.BindText()
    },
    // 右键不可编辑
    editMethod({ row, column, $table }) {
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
    },
    async BindText() {
      const { data: res } = await this.$http.get('/Base/BRole/spacial', {
        params: {
          bAuthorityListID: this.bAuthorityListID,
          roleID: this.roleID
        }
      })
      if (res.isSuccess) {
        this.from = res.data
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 验证
    async validEnter() {
      this.errIndex = []
      const errMap = await this.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
        if (this.errIndex.length > 0) {
          this.$message.error('验证失败,请核对输入数据')
        }
        return false
      } else {
        return true
      }
    },
    cellClassName({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    },
    // table工具栏方法
    toolbarButtonClickEvent({ code }) {
      switch (code) {
        case 'clickToSave':
          this.clickToSave()
          break
      }
    },
    async clickToSave() {
      let insertRecords = this.$refs.xTable.getInsertRecords()
      insertRecords = this.removeArrayNull(insertRecords)
      let removeRecords = this.$refs.xTable.getRemoveRecords()
      let updateRecords = this.$refs.xTable.getUpdateRecords()
      updateRecords = this.removeArrayNull(updateRecords)
      let updateRecord = []
      for (let item of insertRecords) {
        updateRecord.push(item)
      }
      for (let item of removeRecords) {
        item.id = item.id > 0 ? 0 - item.id : item.id
        updateRecord.push(item)
      }
      for (let item of updateRecords) {
        updateRecord.push(item)
      }
      const { data: res } = await this.$http.put('/Base/BRole/spacial', updateRecord)
      if (res.isSuccess) {
        this.$message.success(res.data)
        this.BindText()
      } else {
        this.$message.error(res.errorMessage)
      }
    }
  },
  computed: {
    // card的body高度
    height: function () {
      if (this.formVisible) {
        return '530px'
      } else {
        return '0px'
      }
    }
  }
}
</script>

<style lang="less" scoped></style>
